import { Stack } from '@mui/material';
import { FormBaseLayout } from 'modules/components/layer10';
import { StyledTextField } from 'modules/components/layer01';
import React from 'react';
import * as ds from './dataService';
import { SavePlanSet_Input } from 'generated/graphql';
import _ from 'lodash';
import {
  useLocation,
  useNavigate
} from 'react-router-dom';



export type SavePlanSetFormProps = {
  id?: string;
  projectId?: string;
  handleClose: () => void;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: SavePlanSetFormProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [
    fnSaveForm,
    { loading }
  ] = ds.useSavePlanSet();


  const form = ds.useFormState(props.id ?? '', props.projectId ?? '');


  const handleSubmit = async (input: SavePlanSet_Input) => {
    const cleaned = _.mapValues(input, (node) => {
      if (typeof node === 'string' && node === '') {
        return undefined;
      }
      return node;
    });
    const id = await fnSaveForm(cleaned);

    return id;
  };
  const fields: (keyof ds.IFormState)[] = ['displayName'];
  return (
    <FormBaseLayout.FC
      handleCancel={() => {
        props.handleClose();
      }}
      handleSubmit={async () => {
        const id = await handleSubmit(form.formState);
        if (location.pathname.includes('planSets') && props.id === '') {
          navigate(`${id}`);
        }
        if (id !== props.id && props.id === '') {
          navigate(`../planSets/${id}`);
        } else {
          props.handleClose();
        }
      }}
      cancelButtonText='Cancel'
      isLoading={loading}
    >
      <Stack
        rowGap='1.25rem'
      >
        {fields.map((field, i) => (
          <StyledTextField.FC
            key={i}
            {...form.genFieldProps(field)}
          />
        ))}
      </Stack>
    </FormBaseLayout.FC>
  );
};
